export enum LanguageEnum {
  ZH = "zh",
  EN = "en",
  FR = "fr",
}
